import './DemandedJobs.scss';
import './Categories.scss';
import TalentImg1 from "../../images/Rectangle_1269.png"
import TalentImg2 from "../../images/Rectangle_1328.png"
import TalentImg3 from "../../images/Rectangle_1273.png"
import TalentImg4 from "../../images/Rectangle_1275.png"
import TalentImg5 from "../../images/Rectangle_1277.png"
import Header from '../utils/Header';
import { Link } from 'react-router-dom';
import Carousel from '../utils/Carousel';
import toList from '../utils/ComponentUtil';
import useWindowDimensions from '../utils/WindowDimensions';


function Categories() {
    const categories = [{
        image: TalentImg1,
        title: 'Online Typing',
        to: '/hire-talent/online-typing'
    },
    {
        image: TalentImg2,
        title: 'Video Editing',
        to: '/hire-talent/video-editing'
    },
    {
        image: TalentImg3,
        title: 'Graphics Design',
        to: '/hire-talent/graphics-design'
    },
    {
        image: TalentImg4,
        title: 'Proof Reading',
        to: '/hire-talent/proof-reading'
    },
    {
        image: TalentImg5,
        title: 'Review Writing',
        to: '/hire-talent/review-writing'
    }
    ];

    const { width } = useWindowDimensions();


    return (<div className="categories-wrp wrapper">
        <Header title='Categories' subTitle='' />
        <div className='categories-tiles-wrp'>
            <Carousel numberOfCards={5} arrows={false} centerMode={width <= 768}
                cards={toList(categories, undefined, (c, i) =>
                    <div className='category-tile-wrp' key={"category-" + i}>
                        <Link reloadDocument={true} to={c.to}>
                            <img className='category-img' src={c.image} alt='category' />
                            <div className='category-name'>{c.title}</div>
                        </Link>
                    </div>
                )}
            ></Carousel>
        </div>
    </div>);
}

export default Categories;